import { createSlice } from "@reduxjs/toolkit";

const notificationsProductsSlice = createSlice({
    name: 'notificationsProducts',
    initialState: {
        notificationsProducts: [],
        notifications: [],
    },
    reducers: {
        setNotificationsProducts: (state, action) => {
            state.notificationsProducts = action.payload;
    
        },
        setNotifications: (state, action) => {
            state.notifications = action.payload;     
        }
    }
});

export const { setNotificationsProducts,setNotifications} = notificationsProductsSlice.actions;
export default notificationsProductsSlice.reducer;